import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

@Component({
    selector: 'demo-upp-dialog',
    templateUrl: './demo-upp-dialog.html',
    styleUrls: ['../demo-common.scss', './demo-upp-dialog.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoUppDialogComponent {
    open = false;
    backdropDismiss = true;

    /** Extra lines so the content slot scrolls while header/footer stay fixed. */
    readonly scrollLines = Array.from({ length: 12 }, (_, index) => `Scrollable line ${index + 1}`);

    constructor(private change: ChangeDetectorRef) {}

    OnOpen(): void {
        this.open = true;
        this.change.markForCheck();
    }

    OnClose(): void {
        this.open = false;
        this.change.markForCheck();
    }

    OnToggleBackdrop(): void {
        this.backdropDismiss = !this.backdropDismiss;
        this.change.markForCheck();
    }
}
